import { useEffect, useState } from "react";
import { ArrowDown, ArrowUpRight } from "lucide-react";
import BrandMark from "@/components/BrandMark";
import EditorialImage from "@/components/EditorialImage";
import Reveal from "@/components/Reveal";
import EditorialMarquee from "@/components/EditorialMarquee";
import ServicesSection from "@/components/sections/ServicesSection";
import ImageStorySection from "@/components/sections/ImageStorySection";
import AboutSection from "@/components/sections/AboutSection";
import ProcessSection from "@/components/sections/ProcessSection";
import AudienceSection from "@/components/sections/AudienceSection";
import RegionSection from "@/components/sections/RegionSection";
import ContactSection from "@/components/sections/ContactSection";

const mailto = "mailto:van.akkeren.raeumungsservice@gmail.com?subject=Angebot%20anfragen%20%E2%80%93%20VanAkkeren%20R%C3%A4umungsservice";

export default function HomePage() {
  const [heroShift, setHeroShift] = useState(0);

  useEffect(() => {
    let frame;
    const handleScroll = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => setHeroShift(Math.min(window.scrollY * 0.06, 26)));
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="home-page">
      <section className="hero-section" id="start" data-testid="hero-section-container">
        <div className="container hero-grid">
          <div className="hero-copy">
            <Reveal className="hero-kicker" delay={80}>
              <span className="chapter-label">KAPITEL // 01</span>
              <span className="hero-location">MÜLLHEIM · MARKGRÄFLERLAND</span>
            </Reveal>
            <h1 className="hero-title" data-testid="hero-headline-title">
              <span className="reveal-line"><span style={{ "--line-delay": "160ms" }}>Räumen.</span></span>
              <span className="reveal-line"><span style={{ "--line-delay": "260ms" }}>Transportieren.</span></span>
              <span className="reveal-line hero-title-accent"><span style={{ "--line-delay": "360ms" }}>Umziehen.</span></span>
            </h1>
            <Reveal className="hero-description" delay={470}>
              <p>Zuverlässige Unterstützung bei Entrümpelungen, Haushaltsauflösungen, kleineren Umzügen und Transporten in Müllheim und Umgebung.</p>
            </Reveal>
            <Reveal className="hero-actions" delay={560}>
              <a className="button button-primary" href="tel:+4915568199384" data-testid="hero-cta-phone-button">
                Jetzt anrufen <ArrowUpRight size={17} strokeWidth={1.8} />
              </a>
              <a className="button button-outline" href={mailto} data-testid="hero-cta-inquiry-button">
                Angebot anfragen <ArrowUpRight size={17} strokeWidth={1.8} />
              </a>
            </Reveal>
            <Reveal className="hero-contact-note" delay={650}>
              <span className="hero-note-mark">01</span>
              <span>Direkter Kontakt · 0155 68199384</span>
            </Reveal>
          </div>
          <div className="hero-visual" data-testid="hero-visual-panel">
            <div className="hero-image-wrap" style={{ transform: `translateY(${heroShift}px)` }}>
              <EditorialImage
                src="https://images.unsplash.com/photo-1600725935160-f67ee4f6084a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxtb3ZpbmclMjBib3hlcyUyMGhvbWUlMjBpbnRlcmlvciUyMGNsZWFufGVufDB8fHx8MTc4MTg5MjA3NHww&ixlib=rb-4.1.0&q=85"
                alt="Sorgfältig gepackte Umzugskartons und Wohnaccessoires auf einem Holztisch bei einem privaten Kleinumzug"
                label="BEHUTSAM GEPACKT · KLEINER UMZUG"
                testId="hero-image"
                loading="eager"
                className="hero-image"
              />
              <div className="hero-crest-badge" data-testid="hero-brand-crest-badge">
                <BrandMark testId="hero-brand-mark" />
              </div>
              <div className="hero-visual-index">01 / 05</div>
            </div>
            <div className="hero-visual-caption">
              <span>ORDNUNG BEGINNT MIT EINEM KLAREN SCHRITT</span>
              <ArrowDown size={16} strokeWidth={1.5} />
            </div>
          </div>
        </div>
      </section>
      <EditorialMarquee />
      <ServicesSection />
      <ImageStorySection />
      <AboutSection />
      <ProcessSection />
      <AudienceSection />
      <RegionSection />
      <ContactSection />
    </div>
  );
}
